import { FontsType } from "../types/styles.types";


export const FONTS: FontsType = {
  large: '3rem',
  midLarge: '2.5rem',
  medium: '36px',
  midSmall: '24px',
  small: '20px',
  mini: '14px',
};
